module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 141.87566fcf.png";